<template>
    <v-container fluid>
        <filtro ref="filtro" @filtrar="filtrar"></filtro>
        <v-card class="my-4 px-6 br-15" elevation="0">
            <v-row no-gutters>
                <v-col cols="8" class="px-4 py-4"></v-col>
                <v-col cols="4" class="py-2 d-flex align-end justify-end">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                class="new-button px-8"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>mdi-microsoft-excel</v-icon>
                                Exportar
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="exportar('lista')">
                                <v-list-item-title>Lista</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportar('preco')">
                                <v-list-item-title
                                    >Listagem (valores)</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-item @click="exportar('macro-fornecedor')">
                                <v-list-item-title
                                    >Listagem por macro fornecedor</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-item @click="exportar('categoria')">
                                <v-list-item-title
                                    >Listagem por categoria</v-list-item-title
                                >
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-col>
            </v-row>
            <v-divider class="mx-4"></v-divider>
        </v-card>
        <v-overlay :value="carregando" :z-index="300">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
        <v-dialog
            :persistent="porcentagem < 100"
            content-class="br-15"
            v-model="dialog"
            width="600"
            style="z-index: 5000"
        >
            <v-card>
                <v-toolbar
                    elevation="0"
                    dark
                    class="primary-degrade white--text fix-flex"
                >
                    <v-toolbar-title> Exportando Extrato XLSX </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                        :disabled="porcentagem < 100"
                        fab
                        width="24px"
                        height="24px"
                        elevation="0"
                        light
                        @click="dialog = false"
                    >
                        <v-icon size="18px" color="primary">mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="pa-5">
                    <p class="text-center">
                        {{ mensagemProcessamento }}
                        <span v-if="!erroProcessamento"
                            >({{ porcentagem }}%)</span
                        >
                    </p>
                    <v-progress-linear
                        class="mb-3"
                        :color="erroProcessamento ? 'error' : 'teal'"
                        buffer-value="0"
                        :value="porcentagem"
                        stream
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-data-table
            :headers="headersCalculadora"
            :items="dadosCalculadora"
            :loading="carregando"
            :items-per-page="10"
            :footer-props="{
                'items-per-page-options': [10, 25, 50, 100, 250, 500, -1],
                'items-per-page-text': 'Linhas por página',
                'page-text': '{0}-{1} de {2}',
            }"
            class="elevation-1 br-15"
            show-current-page
        />
    </v-container>
</template>

<script>
import Filtro from "./Filtro.vue";

export default {
    components: {
        Filtro,
    },
    data() {
        return {
            dialog: false,
            carregando: false,
            erroProcessamento: false,
            dadosCalculadora: [],
            porcentagem: 0,
            headersCalculadora: [
                { text: "Ano", value: "ano", align: "center" },
                { text: "Código RD fornecedor", value: "id_fornecedor", align: "center" },
                { text: "Fornecedor", value: "nome_fornecedor", align: "center" },
                { text: "Plano", value: "plano", align: "center" },
                { text: "Pacote", value: "pacote", align: "center" },
                { text: "ID Ativação", value: "id_ativacao", align: "center" },
                { text: "Ativação", value: "nome_ativacao", align: "center" },
                { text: "Total Contratado", value: "essencial", align: "center" },
                { text: "Total Negociado", value: "total_negociado", align: "center" },
                { text: "Total Utilizado", value: "total_utilizado", align: "center" },
                { text: "Disponível", value: "disponivel", align: "center" },
            ],
            mensagemProcessamento: "",
            alerta: false,
            alertaTexto: "",
            alertaColor: "error",
            alertaTimeout: 3000,
        };
    },
    methods: {
        async filtrar() {
            this.carregando = true;

            const filtro = { ...this.$refs.filtro.filtro };
            const data = {
                id_fornecedor: filtro.id_fornecedor,
                id_ativacao: filtro.id_ativacao,
                ano: filtro.ano ?? '2025',
            };

            const response = await this.$http().post("/planejamentoEcommerce/calculadora/lista", data);
            this.carregando = false;

            if (response.data && response.data.length > 0) {
                this.dadosCalculadora = response.data;
            } else {
                this.dadosCalculadora = [];
            }

        },
        async exportar(tipo = 'lista') {
            if (!this.$refs.filtro.validate()) return;
            this.porcentagem = 0;
            this.mensagemProcessamento = "Enviando dados.";
            this.carregando = true;

            const filtro = { ...this.$refs.filtro.filtro };

            const data = {
                id_fornecedor: filtro.id_fornecedor,
                id_ativacao: filtro.id_ativacao,
                ano: filtro.ano ?? '2025',
                tipo: tipo,
            };
            const response = await this.$http().post("/planejamentoEcommerce/calculadora/exportar", data);

            this.carregando = false;
            window.location = this.$http("baseURL") + response.data.url;

        },
    },
};
</script>


<style>
.detalhes {
    font-weight: 500;
}
</style>